import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Eye, X } from "lucide-react";
import ClientPortalPage from "@/pages/ClientPortalPage";
import {
  api,
  CLIENT_PREVIEW_LINK_KEY,
  CLIENT_PREVIEW_TOKEN_KEY,
  formatApiError,
} from "@/lib/api";

export default function AdminClientPreviewPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: "loading", clientName: "", error: "" });

  useEffect(() => {
    let active = true;
    const storedLink = sessionStorage.getItem(CLIENT_PREVIEW_LINK_KEY);
    const storedToken = sessionStorage.getItem(CLIENT_PREVIEW_TOKEN_KEY);
    if (storedLink === token && storedToken) {
      setState({ status: "ready", clientName: "Danışan", error: "" });
      return () => { active = false; };
    }
    sessionStorage.removeItem(CLIENT_PREVIEW_TOKEN_KEY);
    sessionStorage.removeItem(CLIENT_PREVIEW_LINK_KEY);
    api.post(`/admin/client-panel-preview/${encodeURIComponent(token)}/exchange`)
      .then(({ data }) => {
        if (!active) return;
        sessionStorage.setItem(CLIENT_PREVIEW_TOKEN_KEY, data.preview_access_token);
        sessionStorage.setItem(CLIENT_PREVIEW_LINK_KEY, token);
        setState({
          status: "ready",
          clientName: data.client?.full_name || "Danışan",
          error: "",
        });
      })
      .catch((error) => {
        if (!active) return;
        setState({ status: "error", clientName: "", error: formatApiError(error) });
      });
    return () => { active = false; };
  }, [token]);

  const closePreview = () => {
    sessionStorage.removeItem(CLIENT_PREVIEW_TOKEN_KEY);
    sessionStorage.removeItem(CLIENT_PREVIEW_LINK_KEY);
    navigate("/yonetim/danisanlar");
  };

  if (state.status === "loading") {
    return <div className="h-[100dvh] grid place-items-center bg-pleiades-ivory text-sm text-pleiades-slate">Güvenli önizleme hazırlanıyor…</div>;
  }
  if (state.status === "error") {
    return (
      <div className="h-[100dvh] grid place-items-center bg-pleiades-ivory p-5">
        <div className="w-full max-w-md border border-pleiades-border bg-white p-5 text-center">
          <Eye className="mx-auto mb-3 text-pleiades-blue" size={24} />
          <h1 className="text-lg font-semibold">Önizleme açılamadı</h1>
          <p className="mt-2 text-sm text-pleiades-slate">{state.error}</p>
          <button onClick={closePreview} className="mt-5 min-h-11 border border-pleiades-border px-4 text-sm">Danışanlara dön</button>
        </div>
      </div>
    );
  }
  return (
    <div className="h-[100dvh] min-h-0 overflow-hidden flex flex-col bg-pleiades-ivory">
      <div className="shrink-0 border-b border-amber-300 bg-amber-50 px-3 py-2 text-amber-950">
        <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-3">
          <div className="min-w-0 flex items-center gap-2 text-xs sm:text-sm">
            <Eye size={16} className="shrink-0" />
            <span className="truncate"><strong>Salt okunur önizleme:</strong> {state.clientName}. Değişiklikler kaydedilemez.</span>
          </div>
          <button onClick={closePreview} className="shrink-0 inline-flex min-h-9 items-center gap-1 border border-amber-400 bg-white px-3 text-xs font-medium">
            <X size={14} /> Kapat
          </button>
        </div>
      </div>
      <div className="min-h-0 flex-1">
        <ClientPortalPage previewMode />
      </div>
    </div>
  );
}
